import React, { useEffect, useState } from "react";
import TicketList from "../../../../Components/Tickets/TicketList";
import { Button, Input, Modal, Popconfirm, Skeleton, Spin } from "antd";
import { IoIosAddCircleOutline } from "react-icons/io";
import AddAmmafos from "./AddAmmafos";
import axiosInstance from "../../../../Components/axiosInstance/AxiosInstance";
import { useMessage } from "../../../../Components/MessageProvider/MessageProvider";
import { CiDeliveryTruck, CiRedo } from "react-icons/ci";
import { PiPlugsConnectedThin } from "react-icons/pi";
import { GoSearch } from "react-icons/go";
import { AiOutlineDelete } from "react-icons/ai";
import { LiaEdit } from "react-icons/lia";
import EditAmmafos from "./EditAmmafos";
import { IoColorPaletteOutline } from "react-icons/io5";
import "../../../../Components/Tickets/Lists.css";
import { MdKeyboardDoubleArrowRight } from "react-icons/md";
import { Link, useNavigate } from "react-router-dom";
import Printykx from "./Printykx/Printykx";
import FirmActions from "../FirmActions/FirmActions";
import ExcelDownloader from "../../../../Components/Tickets/ExcelDownloader";
import { TicketsStore } from "../../../../Stores/Tickets/TicketsStore";

export default function Ammafos() {
  let [loadingCustomer, setLoadingCustomer] = useState(false);
  let [customer, setCustomer] = useState([]);
  let [isModalOpen, setIsModalOpen] = useState(false);
  let [isColorModalOpen, setIsColorModalOpen] = useState(false);
  let [editModalOpen, setEditModalOpen] = useState(false);
  let [connectModal, setConnectModal] = useState(false);
  const messageApi = useMessage();
  let [selected, setSelected] = useState(new Set());
  let [customers, setCustomers] = useState([]);
  let [color, setColor] = useState(null);
  let [driverModal, setDriverModal] = useState(null);

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (
        // (event.ctrlKey || event.metaKey) &&
        event.key === "+" ||
        event.key === "="
      ) {
        event.preventDefault(); // Prevent browser zoom-in
        setIsModalOpen(!isModalOpen);
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, []);
  const getData = TicketsStore((state) => state.getData);
  let { data, loading, error } = TicketsStore();

  useEffect(() => {
    getData("product=Аммофос&offset=0&limit=50");
  }, []);
  const navigate = useNavigate();

  const handleSearch = async (value) => {
    try {
      setLoadingCustomer(true);

      let { data: info } = await axiosInstance.get(
        "/api/customers/search?search=" + value
      );
      if (info.success) {
        setCustomer([...info.data]);
      }
    } catch (error) {
      if (error?.response?.data?.error) {
        messageApi.open({
          type: "warning",
          content: error?.response?.data?.message,
        });
      } else {
        messageApi.open({
          type: "warning",
          content: error.message,
        });
      }
    } finally {
      setLoadingCustomer(false);
    }
  };
  const handleConnection = async (value) => {
    try {
      let { data: info } = await axiosInstance.post(
        "/api/chiqim-official/ammafos-kaliy/connection",
        {
          customer_id: value,
          id: [...selected],
        }
      );

      if (info.success) {
        setSelected([]);
        setConnectModal(false);
        setCustomer(new Set());

        navigate(0);
      }
    } catch (error) {
      if (error?.response?.data?.error) {
        messageApi.open({
          type: "warning",
          content: error?.response?.data?.message,
        });
      } else {
        messageApi.open({
          type: "warning",
          content: error.message,
        });
      }
    }
  };
  const handleDeletion = async () => {
    try {
      let { data: info } = await axiosInstance.post(
        "/api/chiqim-official/ammafos-kaliy/delete",
        {
          deleted: 1,
          id: [
            ...selected.map((el) => {
              return el.id;
            }),
          ],
        }
      );

      if (info.success) {
        setSelected([]);
        setConnectModal(false);
        setCustomer([]);
      }
    } catch (error) {
      if (error?.response?.data?.error) {
        messageApi.open({
          type: "warning",
          content: error?.response?.data?.message,
        });
      } else {
        messageApi.open({
          type: "warning",
          content: error.message,
        });
      }
    }
  };

  const handleColorChange = async () => {
    try {
      let { data: info } = await axiosInstance.post(
        "/api/chiqim-official/ammafos-kaliy/color",
        {
          bgColor: color,
          id: [
            ...selected.map((el) => {
              return el.id;
            }),
          ],
        }
      );

      if (info.success) {
      }
    } catch (error) {
      if (error?.response?.data?.error) {
        messageApi.open({
          type: "warning",
          content: error?.response?.data?.message,
        });
      } else {
        messageApi.open({
          type: "warning",
          content: error.message,
        });
      }
    }
  };
  // loading
  if (loading) {
    return (
      <div className="pb-[50px]">
        <div className="w-[100%] flex flex-col items-start md:gap-2 overflow-auto">
          <div className=" min-w-[900px] my-1 m-auto  shrink-0 max-w-[900px] w-[100%] grid grid-rows-1 grid-cols-6 gap-3 p-2 justify-items-start content-center items-center  relative text-stone-900 text-bold p-3 cursor-pointer shadow-sm rounded-lg border-[1px] border-indigo-500 hover:text-sky-400 ">
            <Skeleton.Input
              active
              size="small"
              className=" text-[14px] text-[#111827] p-0 m-0 col-span-2 w-[30px] "
            />
            <Skeleton.Input
              active
              size="small"
              className=" text-[14px] text-[#111827] p-0 m-0 w-[30px] "
            />
            <Skeleton.Input
              active
              size="small"
              className=" text-[14px] text-[#111827] p-0 m-0 w-[30px] "
            />
            <Skeleton.Input
              active
              size="small"
              className=" text-[14px] text-[#111827] p-0 m-0 w-[30px] "
            />
            <Skeleton.Input
              active
              size="small"
              className=" text-[14px] text-[#111827] p-0 m-0 w-[30px] "
            />
          </div>
          <div className=" min-w-[900px] my-1 m-auto  shrink-0 max-w-[900px] w-[100%] grid grid-rows-1 grid-cols-6 gap-3 p-2 justify-items-start content-center items-center  relative text-stone-900 text-bold p-3 cursor-pointer shadow-sm rounded-lg border-[1px] border-indigo-500 hover:text-sky-400 ">
            <Skeleton.Input
              active
              size="small"
              className=" text-[14px] text-[#111827] p-0 m-0 col-span-2 w-[30px] "
            />
            <Skeleton.Input
              active
              size="small"
              className=" text-[14px] text-[#111827] p-0 m-0 w-[30px] "
            />
            <Skeleton.Input
              active
              size="small"
              className=" text-[14px] text-[#111827] p-0 m-0 w-[30px] "
            />
            <Skeleton.Input
              active
              size="small"
              className=" text-[14px] text-[#111827] p-0 m-0 w-[30px] "
            />
            <Skeleton.Input
              active
              size="small"
              className=" text-[14px] text-[#111827] p-0 m-0 w-[30px] "
            />
          </div>
          <div className=" min-w-[900px] my-1 m-auto  shrink-0 max-w-[900px] w-[100%] grid grid-rows-1 grid-cols-6 gap-3 p-2 justify-items-start content-center items-center  relative text-stone-900 text-bold p-3 cursor-pointer shadow-sm rounded-lg border-[1px] border-indigo-500 hover:text-sky-400 ">
            <Skeleton.Input
              active
              size="small"
              className=" text-[14px] text-[#111827] p-0 m-0 col-span-2 w-[30px] "
            />
            <Skeleton.Input
              active
              size="small"
              className=" text-[14px] text-[#111827] p-0 m-0 w-[30px] "
            />
            <Skeleton.Input
              active
              size="small"
              className=" text-[14px] text-[#111827] p-0 m-0 w-[30px] "
            />
            <Skeleton.Input
              active
              size="small"
              className=" text-[14px] text-[#111827] p-0 m-0 w-[30px] "
            />
            <Skeleton.Input
              active
              size="small"
              className=" text-[14px] text-[#111827] p-0 m-0 w-[30px] "
            />
          </div>
          <div className=" min-w-[900px] my-1 m-auto  shrink-0 max-w-[900px] w-[100%] grid grid-rows-1 grid-cols-6 gap-3 p-2 justify-items-start content-center items-center  relative text-stone-900 text-bold p-3 cursor-pointer shadow-sm rounded-lg border-[1px] border-indigo-500 hover:text-sky-400 ">
            <Skeleton.Input
              active
              size="small"
              className=" text-[14px] text-[#111827] p-0 m-0 col-span-2 w-[30px] "
            />
            <Skeleton.Input
              active
              size="small"
              className=" text-[14px] text-[#111827] p-0 m-0 w-[30px] "
            />
            <Skeleton.Input
              active
              size="small"
              className=" text-[14px] text-[#111827] p-0 m-0 w-[30px] "
            />
            <Skeleton.Input
              active
              size="small"
              className=" text-[14px] text-[#111827] p-0 m-0 w-[30px] "
            />
            <Skeleton.Input
              active
              size="small"
              className=" text-[14px] text-[#111827] p-0 m-0 w-[30px] "
            />
          </div>
          <div className=" min-w-[900px] my-1 m-auto  shrink-0 max-w-[900px] w-[100%] grid grid-rows-1 grid-cols-6 gap-3 p-2 justify-items-start content-center items-center  relative text-stone-900 text-bold p-3 cursor-pointer shadow-sm rounded-lg border-[1px] border-indigo-500 hover:text-sky-400 ">
            <Skeleton.Input
              active
              size="small"
              className=" text-[14px] text-[#111827] p-0 m-0 col-span-2 w-[30px] "
            />
            <Skeleton.Input
              active
              size="small"
              className=" text-[14px] text-[#111827] p-0 m-0 w-[30px] "
            />
            <Skeleton.Input
              active
              size="small"
              className=" text-[14px] text-[#111827] p-0 m-0 w-[30px] "
            />
            <Skeleton.Input
              active
              size="small"
              className=" text-[14px] text-[#111827] p-0 m-0 w-[30px] "
            />
            <Skeleton.Input
              active
              size="small"
              className=" text-[14px] text-[#111827] p-0 m-0 w-[30px] "
            />
          </div>
          <div className=" min-w-[900px] my-1 m-auto  shrink-0 max-w-[900px] w-[100%] grid grid-rows-1 grid-cols-6 gap-3 p-2 justify-items-start content-center items-center  relative text-stone-900 text-bold p-3 cursor-pointer shadow-sm rounded-lg border-[1px] border-indigo-500 hover:text-sky-400 ">
            <Skeleton.Input
              active
              size="small"
              className=" text-[14px] text-[#111827] p-0 m-0 col-span-2 w-[30px] "
            />
            <Skeleton.Input
              active
              size="small"
              className=" text-[14px] text-[#111827] p-0 m-0 w-[30px] "
            />
            <Skeleton.Input
              active
              size="small"
              className=" text-[14px] text-[#111827] p-0 m-0 w-[30px] "
            />
            <Skeleton.Input
              active
              size="small"
              className=" text-[14px] text-[#111827] p-0 m-0 w-[30px] "
            />
            <Skeleton.Input
              active
              size="small"
              className=" text-[14px] text-[#111827] p-0 m-0 w-[30px] "
            />
          </div>
          <div className=" min-w-[900px] my-1 m-auto  shrink-0 max-w-[900px] w-[100%] grid grid-rows-1 grid-cols-6 gap-3 p-2 justify-items-start content-center items-center  relative text-stone-900 text-bold p-3 cursor-pointer shadow-sm rounded-lg border-[1px] border-indigo-500 hover:text-sky-400 ">
            <Skeleton.Input
              active
              size="small"
              className=" text-[14px] text-[#111827] p-0 m-0 col-span-2 w-[30px] "
            />
            <Skeleton.Input
              active
              size="small"
              className=" text-[14px] text-[#111827] p-0 m-0 w-[30px] "
            />
            <Skeleton.Input
              active
              size="small"
              className=" text-[14px] text-[#111827] p-0 m-0 w-[30px] "
            />
            <Skeleton.Input
              active
              size="small"
              className=" text-[14px] text-[#111827] p-0 m-0 w-[30px] "
            />
            <Skeleton.Input
              active
              size="small"
              className=" text-[14px] text-[#111827] p-0 m-0 w-[30px] "
            />
          </div>
        </div>
      </div>
    );
  }

  if (data?.data?.length == 0 || !data) {
    return (
      <div>
        <main class="grid  place-items-center bg-white px-6 py-24 sm:py-32 lg:px-8">
          <AddAmmafos
            getData={getData}
            isModalOpen={isModalOpen}
            setIsModalOpen={setIsModalOpen}
          />
          <Button
            onClick={() => {
              setIsModalOpen(true);
            }}
            icon={<IoIosAddCircleOutline />}
            size="large"
            className=" rounded-xl fixed bottom-[5%] right-[2%] z-30 bg-white"
          ></Button>
          <div class="text-center">
            {/* <p class="text-base font-semibold text-indigo-600">404</p>
                  <h1 class="mt-4 text-balance text-5xl font-semibold tracking-tight text-gray-900 sm:text-7xl">
                    Page not found
                  </h1> */}
            <p class="mt-6 text-pretty text-lg font-medium text-gray-500 sm:text-xl/8">
              Tiketlar mavjud emas
            </p>
            <div class="mt-10 flex items-center justify-center gap-x-6">
              <Link
                to="/tickets"
                class="rounded-md bg-indigo-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
              >
                Tiketlar
              </Link>
              <Link
                to="/tickets/kirim"
                class="text-sm font-semibold text-gray-900"
              >
                Kirimlar <span aria-hidden="true">&rarr;</span>
              </Link>
            </div>
          </div>
        </main>
      </div>
    );
  }

  return (
    <div>
      <AddAmmafos
        getData={getData}
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
      />
      <EditAmmafos
        getData={getData}
        isModalOpen={editModalOpen}
        setIsModalOpen={setEditModalOpen}
        id={selected?.size == 1 ? selected.values().next().value : null}
      />

      <Printykx
        getData={getData}
        isModalOpen={driverModal}
        setIsModalOpen={setDriverModal}
        id={selected?.size == 1 ? selected.values().next().value : null}
        selectedOne={
          selected?.size == 1
            ? data?.data?.find((el) => el?.id == selected.values().next().value)
            : null
        }
      />
      <Button
        onClick={() => {
          setIsModalOpen(true);
        }}
        icon={<IoIosAddCircleOutline />}
        size="large"
        className=" rounded-xl fixed bottom-[5%] right-[2%] z-30 bg-white"
      ></Button>

      {selected?.size > 0 ? (
        <div
          className={`max-w-[1000px] mb-[5px] shadow-lg rounded-md w-[100%] p-[5px] sticky top-[50px] bg-white	z-50 flex flex-row items-center justify-between transition-opacity duration-50 m-auto `}
        >
          <Button
            onClick={() => {
              setSelected([]);
            }}
            icon={<CiRedo />}
          />

          <div className="flex flex-row items-center gap-2">
            <Button
              onClick={() => {
                setIsColorModalOpen(true);
              }}
              icon={<IoColorPaletteOutline />}
            ></Button>
            {selected?.size === 1 ? (
              <Button
                onClick={() => {
                  setDriverModal(true);
                }}
                icon={<CiDeliveryTruck />}
              />
            ) : null}
            {selected?.size === 1 ? (
              <Button
                onClick={() => {
                  setEditModalOpen(true);
                }}
                icon={<LiaEdit />}
              />
            ) : null}

            <Popconfirm
              title="O'chirish"
              description={" O'chirishga ishonchingiz komilmi?"}
              onConfirm={() => {
                handleDeletion();
              }}
              // onCancel={cancel}
              okText="Yes"
              cancelText="No"
            >
              <Button icon={<AiOutlineDelete />} />
            </Popconfirm>
            <Button
              onClick={() => {
                setConnectModal(true);
                console.log(selected.values().next().value);
              }}
              icon={<PiPlugsConnectedThin />}
            />
          </div>
        </div>
      ) : (
        <></>
      )}

      {/* color tanlash */}
      <Modal
        style={{ top: "10px" }}
        title="Tiketlarni Biriktirish"
        open={isColorModalOpen}
        //   loading={loadVagon}
        onOk={() => {
          setIsColorModalOpen(false);
        }}
        onCancel={() => {
          setIsColorModalOpen(false);
        }}
        footer={[
          <Button
            key="back"
            onClick={() => {
              handleColorChange();
              setIsColorModalOpen(false);
            }}
            style={{ backgroundColor: "#26e90c", color: "#fff" }}
          >
            Saqlash
          </Button>,
        ]}
      >
        <div className="flex flex-row items-center justify-center gap-2 m-auto">
          <input
            type="color"
            value={color}
            onChange={(e) => {
              setColor(e.target.value);
            }}
            id="favcolor"
            name="favcolor"
          />
        </div>
      </Modal>

      {/* ticket biriktirish */}
      <Modal
        style={{ top: "10px" }}
        title="Tiketlarni Biriktirish"
        open={connectModal}
        //   loading={loadVagon}
        onOk={() => {
          setConnectModal(false);
        }}
        onCancel={() => {
          setConnectModal(false);
        }}
        footer={[
          <Button
            key="back"
            onClick={() => {
              setConnectModal(false);
              setSelected([]);
              setCustomer([]);
              getData();
              handleConnection(null);
            }}
            style={{ backgroundColor: "#f5222d", color: "#fff" }}
          >
            Atkaz
          </Button>,
          <Button
            key="back"
            onClick={() => {
              setConnectModal(false);
              setSelected([]);
              setCustomer([]);
              getData();
            }}
            style={{ backgroundColor: "#f5222d", color: "#fff" }}
          >
            Tozalash
          </Button>,
        ]}
      >
        <div className="flex flex-row items-center justify-center gap-2 m-auto">
          <Input
            type="text"
            placeholder="Birikuvchini yozing"
            className="w-[80%]"
            onChange={(e) => {
              handleSearch(e.target.value);
            }}
          />
          <Button icon={<GoSearch />}></Button>
        </div>
        <div className="h-[400px] overflow-auto">
          {loadingCustomer ? (
            <div className="flex flex-row items-center justify-center pt-[60px]">
              <Spin />
            </div>
          ) : null}
          {customer.length == 0 && !loadingCustomer ? (
            <div className="flex flex-row items-center justify-center pt-[60px]">
              <h2>Not found</h2>
            </div>
          ) : null}

          {customer.map((el) => {
            return (
              <Popconfirm
                title="O'chirish"
                description={
                  `'${el.name}'` +
                  "ga " +
                  data?.data?.find(
                    (el) => el?.id == selected.values().next().value
                  )?.ticket?.ticket +
                  " tiket biriktirishga aminmisiz?"
                }
                onConfirm={() => {
                  handleConnection(el.id);
                }}
                // onCancel={cancel}
                okText="Yes"
                cancelText="No"
              >
                <article className="flex items-start space-x-6 p-1 rounded mt-3 hover:cursor-pointer hover:bg-[#94a3b836]">
                  <div className="min-w-0 relative flex-auto">
                    <h2 className="font-semibold text-slate-900 truncate pr-20 text-[14px]">
                      {el.name}
                    </h2>
                    <dl className=" mb-0 flex flex-wrap text-sm leading-6 font-medium">
                      <div className="absolute top-0 right-0 flex items-center space-x-1">
                        <dd className="text-[14px]">{el.phone}</dd>
                      </div>
                      <div>
                        <dt className="sr-only">Rating</dt>
                        <dd className="text-[14px] px-1.5 ring-1 ring-slate-200 rounded">
                          {el.INN}
                        </dd>
                      </div>
                      <div className="ml-2">
                        <dt className="sr-only">Year</dt>
                        <dd className="text-[14px]">{el.written_by}</dd>
                      </div>
                    </dl>
                  </div>
                </article>
              </Popconfirm>
            );
          })}
        </div>
      </Modal>

      {/*  */}
      <ExcelDownloader data={data?.data} />
      <TicketList
        data={data?.data}
        selected={selected}
        setSelected={setSelected}
      />
    </div>
  );
}
